module.exports = __webpack_public_path__ + "static/media/usa.936feee6.svg";